import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import GetCountriesQuery from '../../../../../Query/Countries/Countries';
import { Modal } from '../../../../../../modules/modules';
import Image from '../../../../../../components/Image';
import CountryService from '../../../../../../services/CountryService';

interface ICountrySelectProps {
  onClose: () => void;
}

interface ICountrySelectState {
  search: string;
  redirectTo: string;
}

class CountrySelect extends React.Component<ICountrySelectProps & RouteComponentProps, ICountrySelectState> {

  constructor(props: ICountrySelectProps & RouteComponentProps) {
    super(props);

    this.state = {
      search: '',
      redirectTo: '',
    };

    this.onClose = this.onClose.bind(this);
  }

  public render() {
    const { search } = this.state;

    return (
      <React.Fragment>
        <Modal
          open={true}
          type="countrySelect"
          onClose={this.onClose}
          disableScrollBody={true}
        >
          <GetCountriesQuery
            search={this.state.search}
            withoutContinents={false}
          >
            {({ countries }: any) => {
              if (countries && countries.countries) {

                const world = countries.countries.find((c: GQL.ICountry) => c.parentCountryId === null);
                const regions = countries.countries.filter((c: GQL.ICountry) => c.parentCountryId === world.id);

                return (
                  <div className="modal__box">
                    <div className="modal__head">
                      <div className="modal__title">Choose your country</div>
                      <button className="modal__close" onClick={(e) => this.onClose()} />
                    </div>
                    <div className="modal__body">
                      <div className="search">
                        <input
                          type="text"
                          placeholder="Search"
                          value={search}
                          autoFocus={true}
                          onChange={(e: any) => this.setState({ search: e.target.value })}
                        />
                      </div>
                      <div className="modal__content">

                        {regions.map((r: GQL.ICountry, rIndex: number) => {
                          const countryList = countries.countries
                            .filter((c: GQL.ICountry) => c.parentCountryId === r.id)
                            .filter((c: GQL.ICountry) => !search
                              || c.name.toLowerCase().search(search.toLowerCase()) != -1
                              || c.title.orig.toLowerCase().search(search.toLowerCase()) != -1);

                          if (countryList.length === 0) {
                            return null;
                          }

                          return (
                            <div key={rIndex} className="region">
                              <strong>{r.name}</strong>
                              <div className="cf">
                                {countryList
                                  .map((c: GQL.ICountry, cIndex: number) => (
                                    <div key={cIndex} onClick={() => this.onClose(c)}>
                                      <div className="country cf">
                                        <div className="flag">
                                          {c.flag &&
                                            <Image image={c.flag} alt={c.name} />}
                                        </div>
                                        <div className="name">
                                          <strong>{c.name}</strong><br />
                                          {c.title.orig}
                                        </div>
                                        <div className="info">
                                          {c.details.lang}<br />
                                          {c.currency.value || 'EUR'}
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>);
              }

              return null;
            }}
          </GetCountriesQuery>
        </Modal>
      </React.Fragment>
    );
  }

  private async onClose(country?: GQL.ICountry) {
    if (document) {
      document.body.style.overflow = '';
    }

    if (country) {
      const { history: { push }, location: { pathname, search } } = this.props;
      // Country code urls are not used anymore
      // const localStorageCountry = localStorage.getItem('country');
      // vymazání informace o zemi
      // CountryService.GetInstance().removeCountry();

      // const current = (localStorage && JSON.parse(localStorageCountry || '{}')) as GQL.ICountry;
      // const newUrl = pathname.replace(`/${current.code}`, `/${country.code}`);
      // push(`${newUrl}${search}`);

      // so just set the country and change URL only when currency differs
      // (with this approach, it seems that refresh after changing URL is not needed)
      CountryService.GetInstance().setCountry(country);
      const params = new URLSearchParams(search);
      const currentCurrencyCode = params.get('currency');
      const countryCurrencyCode = country && country.currency && country.currency.value;
      if (currentCurrencyCode !== countryCurrencyCode) {
        if (CountryService.GetInstance().currencyCodePageParam) {
          params.set('currency', countryCurrencyCode);
        } else {
          params.delete('currency');
        }
        const newParamString = params.toString();
        push(`${pathname}${newParamString.length > 0 ? `?${newParamString}` : ''}`);
      }

      // state pro redirect
      this.props.onClose();

      // refresh after changing url
      // (window as any).location = (window as any).location;
    }

    this.props.onClose();
  }
}

export default withRouter(CountrySelect);


// WEBPACK FOOTER //
// ./src/components/Header/components/Country/components/CountrySelect/CountrySelect.tsx